import styled from "styled-components";

export const SimpleRow = styled.div`
  display: flex;
  flex-direction: row;
`;
